import apiClient from '@/services/axios'

export async function put(roleId, payload) {
  var response = await apiClient.put('/roles/' + roleId, payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update Role.')
}
